import styled from "styled-components";

export const AvailabilityWrapper = styled.div`
  height: 70vh;
  overflow: auto;
`